<template>
  <Toaster />

  <RouterView />
</template>

<script lang="ts" setup>
import Toaster from '@gcx-si/vue-components/Toaster'
</script>
